import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { hasAdminRole } from "@/lib/auth-roles"
import { queryClient } from "../../../query-client"
import { meQueryOptions } from "../../../me"

/**
 * Port of app/e2e/[userId]/layout.tsx's server-side guard:
 * non-admins may only view their own PIC dashboard; /cx-qc (+v2) are
 * team-wide read-only views open to any signed-in user.
 */
export const Route = createFileRoute("/e2e/$userId")({
  beforeLoad: async ({ params, location }) => {
    const user = await queryClient.ensureQueryData(meQueryOptions)
    if (!user) throw redirect({ href: "/" })

    const path = location.pathname
    const isCxQc = path.endsWith("/cx-qc")
    if (!isCxQc && !hasAdminRole(user.role) && params.userId !== user.id) {
      throw redirect({ href: `/e2e/${user.id}?tab=nurture&page=1` })
    }
  },
  component: Outlet,
})
